import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import DefaultText from '../../../components/Accessibility/DefaultText';
import PageTitle from '../../../components/Accessibility/PageTitle';
import { ModalCronogramaGCProps } from '../../../interfaces/props/SaudeBemEstar/GestaoCronicos/ModalCronogramaGCProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import './styles.css';
import { sxCloseIconButton, sxModal } from './sxProps';
import TimelineGC from './TimelineGC';


const ModalCronogramaGC: React.FC<ModalCronogramaGCProps> = ({
  showModal, handleShowModal, itensCronograma
}) => {

  const accessibility = useAccessibility();

  return (
    <Modal
      open={showModal ? showModal : false}
      onClose={handleShowModal}
    >
      <Box sx={sxModal} style={{ ...accessibility.textStyleAccessibility, ...accessibility.contrastBorderAccessibility }} className='grow-left-animation'>
        <PageTitle text='Cronograma completo' />
        <DefaultText text='Veja aqui toda a sua linha do tempo no Programa Gestão de crônicos da Unimed Campinas.' />
        <IconButton
          aria-label="Fechar"
          onClick={handleShowModal}
          style={accessibility.buttonStyleAccessibility}
          sx={sxCloseIconButton}
        >
          <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
        </IconButton>
        <div className='modal-cronograma-scroll' tabIndex={-1}>
          <TimelineGC items={itensCronograma} />
        </div>
      </Box>
    </Modal>
  );
};

export default ModalCronogramaGC;
